import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: 60,
    top: 0,
    left: 0,
    zIndex: 999,
    position: 'fixed',
    background: theme.palette.primary.light,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 16,
    paddingRight: 16,
  },
  infoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  info: {
    color: theme.palette.common.black,
    fontSize: '14px',
    lineHeight: '16px',
    display: 'inline',
  },
  link: {
    color: theme.palette.primary.main,
    textDecorationColor: theme.palette.primary.main,
    display: 'inline',
  },
  linkText: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    lineHeight: '16px',
    textDecorationColor: theme.palette.primary.main,
    display: 'inline',
  },
  icon: {
    width: 18,
    height: 'auto',
    fill: theme.palette.primary.main,
  },
}))
